import React from 'react';
import { DateUtilService } from 'src/services';
import { localizationService } from 'src/services';

import './timeline.scss';

export enum TimelineType {
	today = 'todayLine',
	top = 'top',
	ending = 'ending',
	comment = 'comment',
	callLog = 'callLog',
	pumpOut = 'pumpOut',
	email = 'email',
	inspection = 'inspection',
	violation = 'violation',
	enforcement = 'enforcement',
	pastDue = 'pastDue',
	missing = 'missing',
	edit = 'edit',
	cleaning = 'cleaning',
	sentCleaningNotice = 'sentCleaningNotice',
	sentGeneralNotice = 'sentGeneralNotice',
	sendingCleaningNotice = 'sendingCleaningNotice',
	failedCleaningNotice = 'failedCleaningNotice',
	event = 'event',
	incident = 'incident'
}

interface TimelineEventProps {
	eventDateTime?: string;
	showTime?: boolean;
	icon?: JSX.Element;
	iconBackgroundCss?: string;
	isTodayTimeLineDivider?: boolean;
	isEnding?: boolean;
	eventType: TimelineType;
}
const TimelineEventComp: React.SFC<TimelineEventProps> = props => {
	let dateContent;
	let timeContent;

	let content = (
		<div className="timeline-content-panel flex-fill">
			{props.isTodayTimeLineDivider === true ? (
				<div className="today" />
			) : (
				<div className="timeline-content flex-fill">{props.children}</div>
			)}
		</div>
	);

	let dateCss = '';
	let iconCss = ['timeline-icon'];

	if (props.isTodayTimeLineDivider === true) {
		iconCss.push('invisible');
		dateCss = 'today-date';
		dateContent = localizationService.getLocalizedString('screen.timeline.today');
		timeContent = '';
	}

	let timelineCss = ['linko-timeline-event', 'd-flex', props.eventType];
	if (props.isEnding === true) {
		iconCss.push('invisible');
		timelineCss.push('timeline-ending');
		dateContent = '';
		timeContent = '';
		content = (
			<div className="dash-timeline">
				<div className="timeline-content"> </div>
			</div>
		);
	}

	if (props.iconBackgroundCss) {
		iconCss.push(props.iconBackgroundCss);
	}

	if (props.eventDateTime && !props.isTodayTimeLineDivider && DateUtilService.isValidDateTime(props.eventDateTime)) {
		dateContent = DateUtilService.toDisplayDate(props.eventDateTime);
		timeContent = DateUtilService.toDisplayTime(props.eventDateTime);
	}

	const increaseZIndex = (e: any) => {
		if (props.eventType === TimelineType.inspection || props.eventType === TimelineType.sentGeneralNotice) {
			const inspectionTimelineDivs = document.getElementsByClassName('linko-timeline-event inspection');
			for (let i = 0; i < inspectionTimelineDivs.length; i++) {
				if (inspectionTimelineDivs[i].className.includes('timeline-clicked')) {
					inspectionTimelineDivs[i].className = inspectionTimelineDivs[i].className.replaceAll(
						'timeline-clicked',
						''
					);
				}
			}
			if (!e.currentTarget.className.includes('timeline-clicked')) {
				e.currentTarget.className += ' timeline-clicked';
			}
		}
	};

	return (
		<div className={timelineCss.join(' ')} onClick={e => increaseZIndex(e)}>
			<div className="timeline-date-time">
				{props.isTodayTimeLineDivider ? (
					<h3 className={dateCss}>{dateContent}</h3>
				) : (
					<div className={dateCss}>{dateContent}</div>
				)}
				{props.showTime && <div className="time">{timeContent}</div>}
			</div>
			<div className="timeline-icon-panel d-flex flex-row">
				<div className={iconCss.join(' ')}>{props.icon}</div>
			</div>
			{content}
		</div>
	);
};

export const TimelineEvent = TimelineEventComp;
